module.exports = "/images/vendor/flag-icon-css/flags/4x3/mt.svg?a816f3a2978c63034949667c78ebf5fd";